import { createContext } from 'react';

export const listContext = createContext({ rounded: false });
